import React from 'react';
import Lottie from 'react-lottie';
import { LOTTIE } from '../../assets';

const defaultOptions = {
    loop: false,
    autoplay: true, 
    animationData: LOTTIE.COMPLETE
};

const Complete = () =>{
    return(
        <div className="item-center">
            <Lottie options={defaultOptions}
                height='20vh'
                width='20vh'
            />
            <p className='text=large'>{'Bạn đã hoàn thành hết công việc được giao'}</p>
        </div>
    )
}

export default Complete;